export const PUBLIC = process.env.PUBLIC_URL || '';
export const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function navigateTo(path) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function goReservar(servicio) {
  navigateTo(`/bienestar/reservar?servicio=${encodeURIComponent(servicio)}`);
}

export function goContact(topic) {
  navigateTo(`/contacto?servicio=${encodeURIComponent(topic)}`);
}

export function formatAgendaWhen(iso, locale) {
  if (!iso) return '';
  const d = new Date(iso.replace(' ', 'T'));
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(locale === 'en' ? 'en-CO' : 'es-CO', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Bogota',
  });
}

export async function submitBienestarInterest(e, courseId, email, setters) {
  e.preventDefault();
  if (!email.trim()) return;
  setters.setSubmitting(true);
  setters.setError(null);
  try {
    const res = await fetch(`${API_BASE}/bienestar/interest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim(), course: courseId }),
    });
    const data = await res.json();
    if (res.ok && data.success) {
      setters.setSuccess(true);
      setters.setEmail('');
    } else {
      setters.setError(data.message || 'Error al enviar.');
    }
  } catch {
    setters.setError('Error de conexión.');
  } finally {
    setters.setSubmitting(false);
  }
}

export const YOGA_PROGRAMS = [
  {
    id: 'equilibrio',
    titleKey: 'programEquilibrioTitle',
    badgeKey: 'programEquilibrioBadge',
    descKey: 'programEquilibrioDesc',
    priceKey: 'programEquilibrioPrice',
    fullDesc:
      'Serie de 5 clases enfocadas en equilibrios de pie, transiciones dinámicas y preparación para equilibrios de brazos (Bakasana/Cuervo). Incluye: enraizamiento y Drishti, equilibrio sobre una pierna, equilibrio dinámico y transiciones, introducción a Bakasana, integración y equilibrios avanzados.',
    philosophy: 'La quietud en el movimiento. La estabilidad nace de la atención plena.',
  },
  {
    id: 'inversiones',
    titleKey: 'programInversionesTitle',
    badgeKey: 'programInversionesBadge',
    descKey: 'programInversionesDesc',
    priceKey: 'programInversionesPrice',
    fullDesc:
      'Serie de 7 clases para una preparación segura hacia las inversiones. Incluye: cimientos de cintura escapular y muñecas, núcleo de poder (core), Viparita Karani, preparación para Sirsasana, práctica con pared, preparación para parada de manos e integración.',
    philosophy: 'Ver el mundo desde otra perspectiva. La seguridad es la prioridad absoluta.',
  },
];

/** Heroes v2 (archivos en public/images; landings usan primary, hub/tarjetas el mismo set). */
export const BIENESTAR_IMAGES = {
  yoga: {
    primary: 'bienestar-carousel-yoga-1a1.png',
    fallback: 'bienestar-carousel-yoga-meditacion.png',
  },
  training: {
    primary: 'bienestar-carousel-entrenamiento-1a1.png',
    fallback: 'bienestar-carousel-talleres-crecimiento.png',
  },
  conecta: {
    primary: 'bienestar-carousel-conecta-acompanamiento.png',
    fallback: 'bienestar-carousel-conecta-esencia.png',
  },
};

export function bienestarImageUrl(filename) {
  return `${PUBLIC}/images/${filename}`;
}

export const BIENESTAR_LANDING_HERO = {
  yoga: {
    src: bienestarImageUrl(BIENESTAR_IMAGES.yoga.primary),
    fallbackSrc: bienestarImageUrl(BIENESTAR_IMAGES.yoga.fallback),
  },
  training: {
    src: bienestarImageUrl(BIENESTAR_IMAGES.training.primary),
    fallbackSrc: bienestarImageUrl(BIENESTAR_IMAGES.training.fallback),
  },
  conecta: {
    src: bienestarImageUrl(BIENESTAR_IMAGES.conecta.primary),
    fallbackSrc: bienestarImageUrl(BIENESTAR_IMAGES.conecta.fallback),
  },
};

export const HUB_PATHS = [
  {
    id: 'yoga',
    path: '/bienestar/yoga',
    tagKey: 'pathYogaTag',
    titleKey: 'pathYogaTitle',
    descKey: 'pathYogaDesc',
    lineKey: 'hubPathYogaLine',
    ctaKey: 'pathYogaCta',
    src: BIENESTAR_LANDING_HERO.yoga.src,
    fallbackSrc: BIENESTAR_LANDING_HERO.yoga.fallbackSrc,
  },
  {
    id: 'training',
    path: '/bienestar/entrenamiento',
    tagKey: 'pathTrainingTag',
    titleKey: 'pathTrainingTitle',
    descKey: 'pathTrainingDesc',
    lineKey: 'hubPathTrainingLine',
    ctaKey: 'pathTrainingCta',
    src: BIENESTAR_LANDING_HERO.training.src,
    fallbackSrc: BIENESTAR_LANDING_HERO.training.fallbackSrc,
  },
  {
    id: 'conecta',
    path: '/bienestar/conecta',
    tagKey: 'pathConectaTag',
    titleKey: 'pathConectaTitle',
    descKey: 'pathConectaDesc',
    lineKey: 'hubPathConectaLine',
    ctaKey: 'pathConectaCta',
    src: BIENESTAR_LANDING_HERO.conecta.src,
    fallbackSrc: BIENESTAR_LANDING_HERO.conecta.fallbackSrc,
  },
];
